import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { deleteExportFailed, deleteExportSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* deleteExport(action) {
  try {
    const url = `${BACKEND_URL}/api/v1/uploader/${action.payload}`;
    const dataResponse = yield makeRequest(url, {}, action, 'DELETE', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(deleteExportSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(deleteExportFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(deleteExportFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
